import { script, noScript } from '../../templates/gtm.js';

export default class GoogleTagManager {
  static inject() {
    $('body').prepend(noScript);
    $('head').append(script);
  }
}
